import styled from 'styled-components';
;

export const ContainerIcon = styled.div`
  position: absolute;
  cursor: pointer;
  top: 3rem;
  right: 3rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    top: 2.5rem;
    right: 2rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    top: 3rem;
    right: 3rem;
  }
`;
